import { database } from "./database";
import { ref, set, get, onValue } from "firebase/database";
import { defaultSprite } from "@/assets/defaultSprite";

export async function getOpponentData(store: any) {
  const opponentID = store.getOpponentID();
  const data = await get(ref(database, `users/${opponentID}/`));
  const name = data.val().name ?? "Anonymous";
  const rating = data.val().rating ?? 1000;
  const profilePic = data.val().profilePic ?? defaultSprite;
  store.setOpponentInfo(opponentID, name, profilePic, rating);
}

export async function updateDisplayName(id: string, name: string | null) {
  set(ref(database, `users/${id}/name`), name);
}

export async function updateProfilePic(id: string, profilePic: string | null) {
  set(ref(database, `users/${id}/profilePic`), profilePic);
}

export async function updateRating(userID: string, rating: number) {
  set(ref(database, `users/${userID}/rating`), rating);
}

export function listenToDisplayName(id: string, store: any) {
  const dbRef = ref(database, `users/${id}/name`);
  return onValue(dbRef, (snapshot) => {
    store.setDisplayName(snapshot.val() ?? "Anonymous");
  });
}

export function listenToProfilePic(id: string, store: any) {
  const dbRef = ref(database, `users/${id}/profilePic`);
  return onValue(dbRef, (snapshot) => {
    store.setProfilePic(snapshot.val() ?? defaultSprite);
  });
}

export function listenToRating(id: string, store: any) {
  const dbRef = ref(database, `users/${id}/rating`);
  return onValue(dbRef, (snapshot) => {
    store.setRating(snapshot.val() ?? 1000);
  });
}
